// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._12l21wug{margin-inline-end:auto}
._1pfhoahv{margin-block-start:var(--ds-space-600,3pc)}
._6rthoahv{margin-block-end:var(--ds-space-600,3pc)}
._ahbq1wug{margin-inline-start:auto}
._p12f1pl1{max-width:29pc}
._p12fko4j{max-width:19pc}
._y3gn1h6o{text-align:center}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/empty-state/dist/esm/styled/container.compiled.css"],"names":[],"mappings":"AAAA,WAAW,sBAAsB;AACjC,WAAW,0CAA0C;AACrD,WAAW,wCAAwC;AACnD,WAAW,wBAAwB;AACnC,WAAW,cAAc;AACzB,WAAW,cAAc;AACzB,WAAW,iBAAiB","sourcesContent":["._12l21wug{margin-inline-end:auto}\n._1pfhoahv{margin-block-start:var(--ds-space-600,3pc)}\n._6rthoahv{margin-block-end:var(--ds-space-600,3pc)}\n._ahbq1wug{margin-inline-start:auto}\n._p12f1pl1{max-width:29pc}\n._p12fko4j{max-width:19pc}\n._y3gn1h6o{text-align:center}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
